(() => {
  const SELECTOR_SECTION = ".nexo-slider-gallery-section";
  const SELECTOR_SWIPER  = ".nexo-slider-gallery__swiper";
  const STATIC_BREAKPOINT = 768;

  const getBool = (val) => String(val) === "true";

  const getEls = (section) => {
    const slider = section.querySelector(SELECTOR_SWIPER);
    if (!slider) return null;

    return {
      slider,
      nav: slider.querySelector(".nexo-slider-gallery__navigation"),
      next: slider.querySelector(".swiper-button-next"),
      prev: slider.querySelector(".swiper-button-prev"),
      pagination: slider.querySelector(".swiper-pagination"),
    };
  };

  const destroySwiper = (sliderEl) => {
    if (sliderEl && sliderEl.swiper) {
      sliderEl.swiper.destroy(true, true);
    }
  };

  const buildConfig = (mode, els, showArrows) => {
    const base = {
      loop: true,
      speed: 600,
      observeParents: true,
      observer: true,
      pagination: {
        el: els.pagination,
        clickable: true,
        type: "bullets",
      },
    };

    if (showArrows) {
      base.navigation = { nextEl: els.next, prevEl: els.prev };
    }

    if (mode === "carousel") {
      return {
        ...base,
        centeredSlides: true,
        slidesPerView: "auto",
        spaceBetween: 16,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
      };
    }

    // slider + static-mobile share the same behaviour
    return {
      ...base,
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 16,
      breakpoints: {
        0:    { slidesPerView: 1,   slidesPerGroup: 1, spaceBetween: 16 },
        768:  { slidesPerView: 2,   slidesPerGroup: 2, spaceBetween: 16 },
        1200: { slidesPerView: 3.5, slidesPerGroup: 4, spaceBetween: 16 }
      }
    };
  };

  const applyNavVisibility = (els, showArrows, forceHide = false) => {
    if (!els?.nav) return;
    const shouldHide = forceHide || !showArrows;
    els.nav.classList.toggle("is-hidden", shouldHide);
  };

  const ensureState = (section) => {
    const mode = section.dataset.layoutMode || "slider";
    const showArrows = getBool(section.dataset.showArrows);
    const els = getEls(section);
    if (!els) return;

    const isStaticDesktop = (mode === "static" && window.innerWidth >= STATIC_BREAKPOINT);

    // STATIC DESKTOP: destroy swiper and switch to CSS grid
    if (isStaticDesktop) {
      section.classList.add("is-static-desktop");
      destroySwiper(els.slider);
      applyNavVisibility(els, showArrows, true);
      return;
    }

    // Otherwise: slider enabled (slider/carousel/static-mobile)
    section.classList.remove("is-static-desktop");
    applyNavVisibility(els, showArrows, false);

    // Build / rebuild
    destroySwiper(els.slider);
    const effectiveMode = (mode === "static") ? "slider" : mode;
    // eslint-disable-next-line no-undef
    new Swiper(els.slider, buildConfig(effectiveMode, els, showArrows));
  };

  const initSection = (section) => {
    if (!section?.matches?.(SELECTOR_SECTION)) return;

    ensureState(section);

    // Re-evaluate on resize (debounced per section)
    let t = null;
    const onResize = () => {
      window.clearTimeout(t);
      t = window.setTimeout(() => ensureState(section), 150);
    };
    window.addEventListener("resize", onResize);

    section.__nexoGalleryResize = onResize;
  };

  const cleanupSection = (section) => {
    const els = getEls(section);
    if (els) destroySwiper(els.slider);
    if (section?.__nexoGalleryResize) {
      window.removeEventListener("resize", section.__nexoGalleryResize);
      delete section.__nexoGalleryResize;
    }
  };

  // Init existing
  document.querySelectorAll(SELECTOR_SECTION).forEach(initSection);

  // Shopify editor events
  document.addEventListener("shopify:section:load", (event) => {
    const section = event.target?.querySelector?.(SELECTOR_SECTION) || event.target;
    initSection(section);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    const section = event.target?.querySelector?.(SELECTOR_SECTION) || event.target;
    cleanupSection(section);
  });
})();
